import React, { useCallback, useEffect, useState } from "react";
import AdminNavigation from "../AdminNavigation";
import Select from "../../../forms/Select";
import { validateField } from "../../../pages/functions";
import { COUNTRIES, REF_DATA } from "../../../constants";
import { addNotification as notify } from "reapop";
import connect from "react-redux/es/connect/connect";
import { api } from "../../index.api";
import "./prod_styles.css";
import { api_v2 } from "../../NewIndex.api";
import { withRouter } from "react-router-dom";
import { getApplicationRegex } from "../../plugins/utils";

const NewManageIndications = (props) => {
  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const manageIndicationsFields = {
    affiliate: {
      name: "Affiliate",
      value: "",
      rules: { title: "Affiliate", required: true },
    },
    product: {
      name: "Product",
      value: "",
      rules: { title: "Product", required: true },
    },
  };

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  const [fields, setFields] = useState(manageIndicationsFields);
  const [affiliateOptions, setAffiliateOptions] = useState([]);
  const [productList, setProductList] = useState([]);
  const [data, setData] = useState([]);
  const [flag, setFlag] = useState(false);

  const validate = useCallback(
    (e, field) => {
      const inputValue = e.target.value.toLowerCase();
      const ref_Data = props.referenceData.find(function (category) {
        return category.type === REF_DATA;
      }).referenceData;
      const regex = getApplicationRegex(ref_Data);
  
      if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
        // HTML Tags and Script detected, prevent it from being added
        showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
        showNotification(
          "Error!",
          "Validation configuration is missing. Please contact support.",
          "error"
        );
        return;
      }
      const validateFields = validateField(e, field, fields);
      setFields({ ...validateFields });
    },
    [fields]
  );

  useEffect(() => {
    const countryList = props.referenceData.filter(
      (item) => item.type === COUNTRIES
    )[0].countries;
    const affiliateList = countryList
      .map((c) => c.affiliate)
      .filter(onlyUnique)
      .sort();
    const options = affiliateList.map((affiliate) => ({
      value: affiliate,
      label: affiliate,
    }));
    setAffiliateOptions(options);

    // Parse query parameters
    const searchParams = new URLSearchParams(props.location.search);
    const queryAffiliate = searchParams.get("affiliate");
    const queryProductId = searchParams.get("productId");

    // Check if the affiliate is within the options
    if (queryAffiliate && queryProductId) {
      const affiliateExists = options.some(
        (option) => option.value === queryAffiliate
      );
      if (affiliateExists) {
        handleAffiliateChange(queryAffiliate, queryProductId);
      }
    }
  }, [props.referenceData, props.location.search]);

  const handleAffiliateChange = useCallback(
    (affiliateName = null, ProductId = null) => {
      setFlag(false);
      if (affiliateName !== null) {
        const queryParams = {
          affiliate: affiliateName,
        };

        api.admin.indication.getProductIndicationMasterList(
          queryParams,
          (productIndicationMaster) => {
            const productsOptions = productIndicationMaster.PRODUCT_MASTER.map(
              (product) => ({
                value: product.id,
                label: product.name,
              })
            );
            setProductList(productsOptions);
            if (ProductId !== null) {
              const productExists = productsOptions.find(
                (p) => p.value === ProductId
              );
              if (productExists) {
                const updatedFields = { ...fields };
                updatedFields.affiliate.value = affiliateName;
                updatedFields.product.value = ProductId;
                setFields(updatedFields);
                handleProductChange(ProductId);
              }
            }
          },
          () => {
            showNotification(
              "Error",
              "There seems to be some error while fetching data for selected affiliate.",
              "error"
            );
            setProductList([]);
          }
        );
      }
    },
    []
  );

  const handleProductChange = useCallback(
    (value) => {
      if (value) {
        const queryParams = {
          productId: value,
        };
        api.admin.indication.getIndicationList(
          queryParams,
          (res) => IndicationSuccessHandler(res),
          IndicationFailureHandler
        );
      }
    },
    [productList]
  );

  const IndicationSuccessHandler = (res) => {
    let masterIndicationList = [];
    res.forEach((indication) => {
      masterIndicationList.push({
        id: indication.id,
        productId: indication.productId,
        disable: indication.disable,
        hcpApproved: indication.hcpApproved,
        ppApproved: indication.ppApproved,
        employeeApproved: indication.employeeApproved,
        name: indication.name,
        indication_id: indication.indication_id,
      });
    });
    setData(masterIndicationList);
    setFlag(true);
  };

  const IndicationFailureHandler = () => {
    showNotification(
      "Error",
      "There seems to be some error while fetching indications for selected product.",
      "error"
    );
    setFlag(false);
  };

  const handleChange = (index, field, value) => {
    setData((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [field]: value } : row))
    );
    const updatedRow = {
      productId: data[index].productId,
      indicationId: data[index].indication_id,
    };

    if (field === "employeeApproved") {
      updatedRow.employeeApproved = value ? 1 : 0;
    } else if (field === "hcpApproved") {
      updatedRow.hcpApproved = value ? 1 : 0;
    } else {
      updatedRow.ppApproved = value ? 1 : 0;
    }

    //call api
    api_v2.updateProductIndications(updatedRow, (res) =>
      UpdateIndicationHandler(res, updatedRow)
    );
  };
  const UpdateIndicationHandler = useCallback(
    (res, updatedRow) => {
      if (res.status === 200) {
        let name = data.find(
          (indication) => indication.indication_id === updatedRow.indicationId
        ).name;
        showNotification(
          "Success",
          `${name} Indication updated successfully.`,
          "success"
        );
      } else if (res.status === 401) {
        showNotification(
          "Error",
          "You are not authorized to perform this action. Please log in again.",
          "error"
        );
        setTimeout(() => window.location.replace("/"), 3000);
      } else {
        showNotification(
          "Error",
          "There seems to be some error while updating product.",
          "error"
        );
      }
    },
    [data]
  );

  return (
    <div className="v2_container">
      <div className="row">
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">Manage Indications</h3>
            </div>
          </div>
          <div className="row md-4">
            <div className="col-md-4">
              <p>Please select Affiliate to view products</p>
            </div>
          </div>
          <div className="row md-4">
            <div className="col-md-4">
              <Select
                searchable
                clearable={false}
                options={affiliateOptions}
                field={fields.affiliate}
                validate={(e) => validate(e, fields.affiliate)}
                onChange={(selected) => handleAffiliateChange(selected)}
                value={fields.affiliate.value}
              />
            </div>
          </div>
          <div className="row md-4">
            <div className="col-md-4" style={{ marginTop: "10px" }}>
              <p>Please select Product to view associated indications</p>
            </div>
          </div>
          <div className="row md-4">
            <div className="col-md-4">
              <Select
                searchable
                clearable={false}
                options={productList}
                field={fields.product}
                validate={(e) => validate(e, fields.product)}
                onChange={(e) => handleProductChange(e)}
                value={fields.product.value}
              />
            </div>
          </div>
          {flag && data.length === 0 && (
            <div className="row">
              <div
                style={{
                  paddingTop: "10px",
                  fontWeight: "bold",
                  paddingLeft: "10px",
                }}
              >
                No indications available for this product.
              </div>
            </div>
          )}
          {flag && data.length > 0 && (
            <div className="row">
              <div style={{ paddingTop: "20px", width: "100%" }}>
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th style={{ textAlign: "center" }}>Employee</th>
                      <th style={{ textAlign: "center" }}>HCP</th>
                      <th style={{ textAlign: "center" }}>Patient</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((entry, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            fontSize: "medium",
                            fontStyle: "inherit",
                            fontWeight: "bold",
                            width: "400px",
                          }}
                        >
                          {entry.name}
                        </td>
                        <td>
                          <input
                            id={index}
                            title="Employee"
                            type="checkbox"
                            checked={entry.employeeApproved}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "employeeApproved",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            id={index}
                            title="HCP"
                            type="checkbox"
                            checked={entry.hcpApproved}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "hcpApproved",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            id={index}
                            title="Patient"
                            type="checkbox"
                            checked={entry.ppApproved}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "ppApproved",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default withRouter(
  connect(mapStateToProps, { notify })(NewManageIndications)
);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Product_Mangement/NewManageIndications.js